import { Button, Container as BaseContainer, styled, Typography } from "@material-ui/core";
import { brand } from "../../theme";

export const Container = styled(({ ...p }) => <div {...p} />)({
  minHeight: "100vh",
  background: brand.surface,
});

export const InnerContainer = styled(({ ...p }) => (
  <BaseContainer maxWidth="sm" {...p} />
))(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(5),
  backgroundColor: brand.surface,
  minHeight: "100%",
}));

export const CancelButton = styled(({ ...p }) => (
  <Button color="inherit" {...p}>
    Cancel
  </Button>
))(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.6,
  textTransform: "uppercase",
  minWidth: "auto",
}));

export const SaveButton = styled(({ ...p }) => (
  <Button color="inherit" type="button" {...p}>
    Save
  </Button>
))(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 0.6,
  textTransform: "uppercase",
  minWidth: "auto",
}));

export const Heading = styled(({ ...p }) => <Typography variant="h4" {...p} />)({
  fontWeight: 700,
  fontSize: 28,
  letterSpacing: -0.5,
  color: brand.text,
  lineHeight: 1.15,
});

export const Subheading = styled(({ ...p }) => <Typography {...p} />)(({ theme }) => ({
  fontSize: 14,
  color: brand.textSec,
  marginTop: theme.spacing(1),
  lineHeight: 1.5,
}));

export const Form = styled(({ ...p }) => <form noValidate="novalidate" {...p} />)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  })
);

export const FeedbackStack = styled(({ ...p }) => <div {...p} />)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  })
);

export const LogoutSection = styled(({ ...p }) => <div {...p} />)(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: theme.spacing(1),
}));

export const LogoutButton = styled(({ ...p }) => <Button {...p} />)({
  width: "100%",
  height: 52,
  borderRadius: 14,
  background: brand.error,
  color: brand.white,
  fontSize: 13,
  fontWeight: 800,
  letterSpacing: 1,
  textTransform: "uppercase",
  boxShadow: `0 4px 18px ${brand.error}55`,
  gap: 8,
  "&:hover": {
    background: "#b73333",
  },
  "&.Mui-disabled": {
    color: brand.white,
    opacity: 0.7,
  },
});

export const LogoutHint = styled(({ ...p }) => <Typography {...p} />)(({ theme }) => ({
  fontSize: 12,
  color: brand.textDis,
  textAlign: "center",
  marginTop: theme.spacing(0.5),
}));
